import Customer from './customer';

export default Customer;